import React from 'react'

import useShouldHideForRedirect from 'containers/DealerRedirector/useShouldHideForRedirect'
import useUser from 'hooks/useUser'

import { useBrandConfig } from '../../contexts/BrandConfigContextProvider'
import { FooterContainer, FooterText, FooterWrapper } from './Footer.styled'

function Footer(): JSX.Element | null {
    const { isLoggedIn } = useUser()
    const { footerText, hideFooterAtLogin } = useBrandConfig()
    const shouldHideForRedirect = useShouldHideForRedirect()

    if (isLoggedIn === undefined) {
        return null
    }

    if (shouldHideForRedirect) {
        return null
    }

    // Data-driven branding is always on
    if (!isLoggedIn && hideFooterAtLogin) {
        return null
    }

    if (!footerText) {
        return null
    }

    return (
        <FooterWrapper className="footer-wrapper">
            <FooterContainer className="footer-container">
                <FooterText>{footerText}</FooterText>
            </FooterContainer>
        </FooterWrapper>
    )
}

export default Footer
